// // // import React, { useEffect, useMemo, useState } from "react";
// // // import styled from "styled-components";
// // // import { FaCheckCircle, FaLock } from "react-icons/fa";
// // // import Navbar from "./Navbar";
// // // import DashboardHeader from "./DashboardHeader";
// // // import Footer from "./Footer";
// // // import api from "../api";
// // // import { useTheme } from "../App"; // 🔥 Import the global theme hook

// // // /* ================= HELPERS ================= */
// // // const getCurrentMonthName = () => {
// // //   const date = new Date();
// // //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // // };

// // // // Generate a list of months for the dropdown
// // // const generateMonthOptions = () => {
// // //   const months = [];
// // //   const date = new Date();
// // //   date.setMonth(date.getMonth() - 3); 
// // //   for (let i = 0; i < 12; i++) {
// // //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// // //     date.setMonth(date.getMonth() + 1);
// // //   }
// // //   return months;
// // // };



// // // const parseScoreValue = (value) => {
// // //   if (value === "N/A" || value === "" || value == null) return null;
// // //   const num = Number(value);
// // //   return Number.isNaN(num) ? null : num;
// // // };


// // // /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// // // const Container = styled.div`
// // //   --sidebar-expanded: 260px; --sidebar-collapsed: 90px;
  
// // //   /* 🔥 THEME VARIABLES 🔥 */
// // //   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
// // //   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
// // //   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
// // //   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
// // //   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
// // //   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
// // //   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#fef2f2'};
// // //   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
  
// // //   /* Summary Box Themes */
// // //   --calc-red-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, #450a0a 0%, #7f1d1d 100%)' : 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)'};
// // //   --calc-orange-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, #7c2d12 0%, #9a3412 100%)' : 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)'};
  
// // //   min-height: 100vh; background: var(--page-bg); color: var(--text-main);
// // //   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// // //   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;
// // //   @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
// // //   @media (max-width: 768px) { margin-left: 0; }
// // // `;

// // // const Main = styled.main`
// // //   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 4px 0 40px;
// // //   @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 86px 0 32px; }
// // //   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 24px; }
// // //     @media (max-width: 1024px) {
// // //     width: min(100%, calc(100% - 24px));
// // //     padding: 12px 0 32px;
// // //   }

// // //   @media (max-width: 576px) {
// // //     width: min(100%, calc(100% - 16px));
// // //     padding: 12px 0 24px;
// // //   }
// // // `;



// // // const HeroPanel = styled.div`
// // //   background: linear-gradient(135deg, #0f172a 0%, #991b1b 45%, #dc2626 100%); color: white; padding: 28px; border-radius: 28px; box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); position: relative; overflow: hidden;
// // //   @media (max-width: 576px) { padding: 22px 18px; border-radius: 22px; }
// // // `;

// // // const HeroTitle = styled.h1` margin: 0; font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; margin-bottom: 14px; `;


// // // /* ================= MODAL COMPONENTS ================= */
// // // const ModalOverlay = styled.div` position: fixed; inset: 0; background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; `;
// // // const ModalContent = styled.div` background: var(--card-bg); padding: 32px; border-radius: 24px; width: 90%; max-width: 420px; text-align: center; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); border: 1px solid #fee2e2; `;
// // // const ModalIcon = styled.div` width: 64px; height: 64px; background: rgba(239, 68, 68, 0.1); color: #ef4444; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 32px; font-weight: bold; margin: 0 auto 20px; `;
// // // const ModalTitle = styled.h3` margin: 0 0 12px; font-size: 1.25rem; font-weight: 800; color: var(--text-main); `;
// // // const ModalText = styled.p` margin: 0 0 24px; color: var(--text-soft); line-height: 1.5; font-size: 0.95rem; `;
// // // const ModalButton = styled.button` background: linear-gradient(135deg, #dc2626, #ef4444); color: white; border: none; padding: 12px 32px; border-radius: 12px; font-weight: 700; font-size: 1rem; cursor: pointer; transition: transform 0.2s; &:hover { transform: translateY(-2px); } `;

// // // //MonthlyTr
// // // /* ================= COMPONENT ================= */
// // // const PerformanceOnGoals = ({ user, collapsed, setCollapsed }) => {

// // //   // Custom Validation State
// // //   const [showWarningModal, setShowWarningModal] = useState(false);
// // //   const [warningMessage, setWarningMessage] = useState("");

// // //   const availableMonths = useMemo(() => generateMonthOptions(), []);

// // //   // 🔥 GLOBAL THEME HOOK 🔥
// // //   const { isDarkMode } = useTheme();

// // //   // 🔥 GLOBAL MONTH LOGIC 🔥
// // //   const [selectedMonth, setSelectedMonth] = useState(
// // //     localStorage.getItem("globalSelectedMonth") || getCurrentMonthName()
// // //   );

// // //   useEffect(() => {
// // //     localStorage.setItem("globalSelectedMonth", selectedMonth);
// // //   }, [selectedMonth]);





// // //   return (
// // //     // 🔥 PASS THE THEME STATE TO THE CONTAINER 🔥
// // //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// // //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// // //       <DashboardHeader user={user} collapsed={collapsed} title="Performance on Goals" />

// // //       {/* Dynamic Warning Modal */}
// // //       {showWarningModal && (
// // //         <ModalOverlay onClick={() => setShowWarningModal(false)}>
// // //           <ModalContent onClick={(e) => e.stopPropagation()}>
// // //             <ModalIcon>!</ModalIcon>
// // //             <ModalTitle>Missing Requirements</ModalTitle>
// // //             <ModalText>
// // //               {warningMessage}
// // //             </ModalText>
// // //             <ModalButton onClick={() => setShowWarningModal(false)}>Got it</ModalButton>
// // //           </ModalContent>
// // //         </ModalOverlay>
// // //       )}

// // //       <Main>
// // //         {/* <Hero> */}
// // //           <HeroPanel>
// // //             <HeroTitle>Live Program</HeroTitle>
// // //           </HeroPanel>
// // //         {/* </Hero> */}
// // //       </Main>
// // //       <Footer />
// // //     </Container>
// // //   );
// // // };

// // // export default PerformanceOnGoals;




// // import React, { useEffect, useMemo, useState } from "react";
// // import styled from "styled-components";
// // // 🔥 Added new icons for the video player actions
// // import { FaCheckCircle, FaLock, FaThumbsUp, FaRegThumbsUp, FaComment, FaShare, FaPaperPlane } from "react-icons/fa";
// // import Navbar from "./Navbar";
// // import DashboardHeader from "./DashboardHeader";
// // import Footer from "./Footer";
// // import api from "../api";
// // import { useTheme } from "../App"; 

// // /* ================= HELPERS ================= */
// // const getCurrentMonthName = () => {
// //   const date = new Date();
// //   return date.toLocaleString("default", { month: "long", year: "numeric" });
// // };

// // const generateMonthOptions = () => {
// //   const months = [];
// //   const date = new Date();
// //   date.setMonth(date.getMonth() - 3); 
// //   for (let i = 0; i < 12; i++) {
// //     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
// //     date.setMonth(date.getMonth() + 1);
// //   }
// //   return months;
// // };

// // const parseScoreValue = (value) => {
// //   if (value === "N/A" || value === "" || value == null) return null;
// //   const num = Number(value);
// //   return Number.isNaN(num) ? null : num;
// // };

// // /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// // const Container = styled.div`
// //   --sidebar-expanded: 260px; --sidebar-collapsed: 90px;
  
// //   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
// //   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
// //   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
// //   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
// //   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
// //   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
// //   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#fef2f2'};
// //   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
  
// //   min-height: 100vh; background: var(--page-bg); color: var(--text-main);
// //   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
// //   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;
// //   @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
// //   @media (max-width: 768px) { margin-left: 0; }
// // `;

// // const Main = styled.main`
// //   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 4px 0 40px;
// //   @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 86px 0 32px; }
// //   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 24px; }
// // `;

// // const HeroPanel = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #991b1b 45%, #dc2626 100%); color: white; padding: 28px; border-radius: 28px; box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); position: relative; overflow: hidden; margin-bottom: 24px;
// //   @media (max-width: 576px) { padding: 22px 18px; border-radius: 22px; }
// // `;

// // const HeroTitle = styled.h1` margin: 0; font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; margin-bottom: 14px; `;

// // /* ================= NEW VIDEO & SOCIAL COMPONENTS ================= */
// // const VideoSection = styled.div`
// //   background: var(--card-bg);
// //   border-radius: 24px;
// //   overflow: hidden;
// //   box-shadow: 0 10px 30px rgba(0,0,0,0.1);
// //   border: 1px solid var(--border);
// // `;

// // const VideoWrapper = styled.div`
// //   position: relative;
// //   padding-top: 56.25%; /* 16:9 Aspect Ratio */
// //   background: #000;
  
// //   video {
// //     position: absolute;
// //     top: 0;
// //     left: 0;
// //     width: 100%;
// //     height: 100%;
// //   }
// // `;

// // const InteractionsContainer = styled.div`
// //   padding: 20px 28px;
// // `;

// // const ActionRow = styled.div`
// //   display: flex;
// //   gap: 24px;
// //   align-items: center;
// //   border-bottom: 1px solid var(--border);
// //   padding-bottom: 16px;
// //   margin-bottom: 16px;
// // `;

// // const ActionButton = styled.button`
// //   background: transparent;
// //   border: none;
// //   display: flex;
// //   align-items: center;
// //   gap: 8px;
// //   color: ${({ $active }) => $active ? '#ef4444' : 'var(--text-soft)'};
// //   font-size: 1.05rem;
// //   font-weight: 600;
// //   cursor: pointer;
// //   transition: all 0.2s;

// //   &:hover {
// //     color: ${({ $active }) => $active ? '#dc2626' : 'var(--text-main)'};
// //     transform: translateY(-2px);
// //   }

// //   svg {
// //     font-size: 1.2rem;
// //   }
// // `;

// // const CommentsSection = styled.div`
// //   margin-top: 20px;
// // `;

// // const CommentInputWrapper = styled.form`
// //   display: flex;
// //   gap: 12px;
// //   margin-bottom: 24px;
// // `;

// // const CommentInput = styled.input`
// //   flex: 1;
// //   padding: 14px 20px;
// //   border-radius: 99px;
// //   border: 1px solid var(--border);
// //   background: var(--input-bg);
// //   color: var(--text-main);
// //   outline: none;
// //   transition: border 0.3s;

// //   &:focus {
// //     border-color: #ef4444;
// //   }
// // `;

// // const SubmitCommentBtn = styled.button`
// //   background: #ef4444;
// //   color: white;
// //   border: none;
// //   width: 48px;
// //   height: 48px;
// //   border-radius: 50%;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   cursor: pointer;
// //   transition: background 0.2s;

// //   &:hover {
// //     background: #dc2626;
// //   }
// // `;

// // const CommentList = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: 16px;
// // `;

// // const CommentItem = styled.div`
// //   display: flex;
// //   gap: 12px;
// // `;

// // const Avatar = styled.div`
// //   width: 40px;
// //   height: 40px;
// //   border-radius: 50%;
// //   background: linear-gradient(135deg, #3b82f6, #2563eb);
// //   color: white;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   font-weight: bold;
// //   flex-shrink: 0;
// // `;

// // const CommentContent = styled.div`
// //   background: var(--input-bg);
// //   padding: 12px 16px;
// //   border-radius: 0 16px 16px 16px;
// //   border: 1px solid var(--border);
// // `;

// // const CommentName = styled.h4`
// //   margin: 0 0 4px 0;
// //   font-size: 0.9rem;
// //   color: var(--text-main);
// // `;

// // const CommentText = styled.p`
// //   margin: 0;
// //   font-size: 0.95rem;
// //   color: var(--text-soft);
// // `;

// // /* ================= MODAL COMPONENTS ================= */
// // const ModalOverlay = styled.div` position: fixed; inset: 0; background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; `;
// // const ModalContent = styled.div` background: var(--card-bg); padding: 32px; border-radius: 24px; width: 90%; max-width: 420px; text-align: center; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); border: 1px solid #fee2e2; `;
// // const ModalIcon = styled.div` width: 64px; height: 64px; background: rgba(239, 68, 68, 0.1); color: #ef4444; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 32px; font-weight: bold; margin: 0 auto 20px; `;
// // const ModalTitle = styled.h3` margin: 0 0 12px; font-size: 1.25rem; font-weight: 800; color: var(--text-main); `;
// // const ModalText = styled.p` margin: 0 0 24px; color: var(--text-soft); line-height: 1.5; font-size: 0.95rem; `;
// // const ModalButton = styled.button` background: linear-gradient(135deg, #dc2626, #ef4444); color: white; border: none; padding: 12px 32px; border-radius: 12px; font-weight: 700; font-size: 1rem; cursor: pointer; transition: transform 0.2s; &:hover { transform: translateY(-2px); } `;


// // /* ================= COMPONENT ================= */
// // const PerformanceOnGoals = ({ user, collapsed, setCollapsed }) => {
// //   const [showWarningModal, setShowWarningModal] = useState(false);
// //   const [warningMessage, setWarningMessage] = useState("");

// //   const { isDarkMode } = useTheme();
// //   const [selectedMonth, setSelectedMonth] = useState(
// //     localStorage.getItem("globalSelectedMonth") || getCurrentMonthName()
// //   );

// //   useEffect(() => {
// //     localStorage.setItem("globalSelectedMonth", selectedMonth);
// //   }, [selectedMonth]);

// //   // 🔥 Social Interaction States
// //   const [isLiked, setIsLiked] = useState(false);
// //   const [likeCount, setLikeCount] = useState(128);
// //   const [showComments, setShowComments] = useState(false);
// //   const [newComment, setNewComment] = useState("");
// //   const [comments, setComments] = useState([
// //     { id: 1, name: "Sarah J.", text: "This live stream is incredibly helpful, thank you!" },
// //     { id: 2, name: "Michael T.", text: "Praise God! Tuning in from Lagos." }
// //   ]);

// //   // 🔥 Handlers
// //   const handleLike = () => {
// //     setIsLiked(!isLiked);
// //     setLikeCount(prev => isLiked ? prev - 1 : prev + 1);
// //   };

// //   const handleShare = async () => {
// //     const shareData = {
// //       title: 'Join this Live Stream!',
// //       text: 'Watch this live program and join the conversation.',
// //       url: window.location.href
// //     };

// //     try {
// //       if (navigator.share) {
// //         await navigator.share(shareData);
// //       } else {
// //         // Fallback for desktop browsers that don't support native share
// //         await navigator.clipboard.writeText(window.location.href);
// //         alert("Link copied to clipboard!");
// //       }
// //     } catch (err) {
// //       console.error('Error sharing:', err);
// //     }
// //   };

// //   const handleCommentSubmit = (e) => {
// //     e.preventDefault();
// //     if (!newComment.trim()) return;

// //     const comment = {
// //       id: Date.now(),
// //       name: user?.name || "Guest User", // Grabs current user's name
// //       text: newComment
// //     };

// //     setComments([comment, ...comments]); // Add to top of list
// //     setNewComment("");
// //   };

// //   return (
// //     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
// //       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
// //       <DashboardHeader user={user} collapsed={collapsed} title="Performance on Goals" />

// //       {showWarningModal && (
// //         <ModalOverlay onClick={() => setShowWarningModal(false)}>
// //           <ModalContent onClick={(e) => e.stopPropagation()}>
// //             <ModalIcon>!</ModalIcon>
// //             <ModalTitle>Missing Requirements</ModalTitle>
// //             <ModalText>{warningMessage}</ModalText>
// //             <ModalButton onClick={() => setShowWarningModal(false)}>Got it</ModalButton>
// //           </ModalContent>
// //         </ModalOverlay>
// //       )}

// //       <Main>
// //         <HeroPanel>
// //           <HeroTitle>Live Program</HeroTitle>
// //         </HeroPanel>

// //         {/* 🔥 NEW VIDEO AND INTERACTION SECTION */}
// //         <VideoSection>
// //           <VideoWrapper>
// //             <video 
// //               controls 
// //               autoPlay 
// //               muted
// //               poster="https://images.unsplash.com/photo-1516383274235-5f42d6c6426d?auto=format&fit=crop&q=80&w=1200"
// //             >
// //               {/* Replace src with your actual video or stream URL */}
// //               <source src="https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/d05QaWd1VGhpdkI1cHRTamN0UDJqUT09/RECEIVE_SALVATION.mp4" type="video/mp4" />
// //               Your browser does not support the video tag.
// //             </video>
// //           </VideoWrapper>

// //           <InteractionsContainer>
// //             <ActionRow>
// //               <ActionButton $active={isLiked} onClick={handleLike}>
// //                 {isLiked ? <FaThumbsUp /> : <FaRegThumbsUp />} 
// //                 {likeCount}
// //               </ActionButton>
              
// //               <ActionButton onClick={() => setShowComments(!showComments)}>
// //                 <FaComment /> {comments.length} Comments
// //               </ActionButton>

// //               <ActionButton onClick={handleShare}>
// //                 <FaShare /> Share
// //               </ActionButton>
// //             </ActionRow>

// //             {/* Comments Area (Toggles open/closed) */}
// //             {showComments && (
// //               <CommentsSection>
// //                 <CommentInputWrapper onSubmit={handleCommentSubmit}>
// //                   <CommentInput 
// //                     placeholder="Write a comment..." 
// //                     value={newComment}
// //                     onChange={(e) => setNewComment(e.target.value)}
// //                   />
// //                   <SubmitCommentBtn type="submit" disabled={!newComment.trim()}>
// //                     <FaPaperPlane />
// //                   </SubmitCommentBtn>
// //                 </CommentInputWrapper>

// //                 <CommentList>
// //                   {comments.map(comment => (
// //                     <CommentItem key={comment.id}>
// //                       <Avatar>{comment.name.charAt(0).toUpperCase()}</Avatar>
// //                       <CommentContent>
// //                         <CommentName>{comment.name}</CommentName>
// //                         <CommentText>{comment.text}</CommentText>
// //                       </CommentContent>
// //                     </CommentItem>
// //                   ))}
// //                 </CommentList>
// //               </CommentsSection>
// //             )}
// //           </InteractionsContainer>
// //         </VideoSection>

// //       </Main>
// //       <Footer />
// //     </Container>
// //   );
// // };

// // export default PerformanceOnGoals;


// // videoLeadRoutes

// import React, { useEffect, useMemo, useState, useRef } from "react";
// import styled from "styled-components";
// import { 
//   FaCheckCircle, FaLock, FaThumbsUp, FaRegThumbsUp, 
//   FaComment, FaShare, FaPaperPlane, FaHeart, FaRegHeart,
//   FaPlay, FaPause, FaExpand, FaCompress, FaVolumeUp,
//   FaVolumeMute, FaSpinner
// } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api";
// import { useTheme } from "../App"; 

// /* ================= HELPERS ================= */
// const getCurrentMonthName = () => {
//   const date = new Date();
//   return date.toLocaleString("default", { month: "long", year: "numeric" });
// };

// const generateMonthOptions = () => {
//   const months = [];
//   const date = new Date();
//   date.setMonth(date.getMonth() - 3); 
//   for (let i = 0; i < 12; i++) {
//     months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
//     date.setMonth(date.getMonth() + 1);
//   }
//   return months;
// };

// const parseScoreValue = (value) => {
//   if (value === "N/A" || value === "" || value == null) return null;
//   const num = Number(value);
//   return Number.isNaN(num) ? null : num;
// };

// /* ================= PAGE LAYOUT & THEME VARIABLES ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px; --sidebar-collapsed: 90px;
  
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
//   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
//   --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#fef2f2'};
//   --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
  
//   min-height: 100vh; background: var(--page-bg); color: var(--text-main);
//   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;
//   @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
//   @media (max-width: 768px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 4px 0 40px;
//   @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 86px 0 32px; }
//   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 24px; }
// `;

// const HeroPanel = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #991b1b 45%, #dc2626 100%); 
//   color: white; padding: 28px; border-radius: 28px; 
//   box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); 
//   position: relative; overflow: hidden; margin-bottom: 24px;
  
//   @media (max-width: 576px) { padding: 22px 18px; border-radius: 22px; }
// `;

// const HeroTitle = styled.h1` 
//   margin: 0; font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem); 
//   line-height: 1.1; font-weight: 800; margin-bottom: 14px; 
// `;

// /* ================= VIDEO PLAYER COMPONENTS ================= */
// const VideoSection = styled.div`
//   background: var(--card-bg);
//   border-radius: 24px;
//   overflow: hidden;
//   box-shadow: 0 10px 30px rgba(0,0,0,0.1);
//   border: 1px solid var(--border);
// `;

// const VideoWrapper = styled.div`
//   position: relative;
//   padding-top: 56.25%;
//   background: #000;
  
//   video {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background: #000;
//   }
// `;

// const LiveBadge = styled.div`
//   position: absolute;
//   top: 20px;
//   left: 20px;
//   background: #ef4444;
//   color: white;
//   padding: 6px 16px;
//   border-radius: 99px;
//   font-weight: 700;
//   font-size: 0.85rem;
//   z-index: 10;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   animation: pulse 1.5s ease-in-out infinite;
  
//   @keyframes pulse {
//     0%, 100% { opacity: 1; }
//     50% { opacity: 0.5; }
//   }
  
//   .dot {
//     width: 8px;
//     height: 8px;
//     background: white;
//     border-radius: 50%;
//   }
// `;

// const VideoControls = styled.div`
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   padding: 20px;
//   background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
//   z-index: 10;
//   display: flex;
//   align-items: center;
//   gap: 16px;
//   opacity: ${({ $visible }) => $visible ? '1' : '0'};
//   transition: opacity 0.3s;
// `;

// const ControlButton = styled.button`
//   background: none;
//   border: none;
//   color: white;
//   font-size: 1.4rem;
//   cursor: pointer;
//   padding: 4px 8px;
//   transition: transform 0.2s;
  
//   &:hover {
//     transform: scale(1.1);
//   }
// `;

// const ProgressBar = styled.input`
//   flex: 1;
//   -webkit-appearance: none;
//   background: rgba(255,255,255,0.3);
//   height: 4px;
//   border-radius: 2px;
//   outline: none;
  
//   &::-webkit-slider-thumb {
//     -webkit-appearance: none;
//     width: 12px;
//     height: 12px;
//     border-radius: 50%;
//     background: #ef4444;
//     cursor: pointer;
//   }
// `;

// const TimeDisplay = styled.span`
//   color: white;
//   font-size: 0.85rem;
//   font-weight: 500;
//   min-width: 80px;
// `;

// /* ================= INTERACTIONS COMPONENTS ================= */
// const InteractionsContainer = styled.div`
//   padding: 20px 28px;
  
//   @media (max-width: 576px) {
//     padding: 16px;
//   }
// `;

// const ActionRow = styled.div`
//   display: flex;
//   gap: 24px;
//   align-items: center;
//   border-bottom: 1px solid var(--border);
//   padding-bottom: 16px;
//   margin-bottom: 16px;
//   flex-wrap: wrap;
  
//   @media (max-width: 576px) {
//     gap: 16px;
//   }
// `;

// const ActionButton = styled.button`
//   background: transparent;
//   border: none;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   color: ${({ $active }) => $active ? '#ef4444' : 'var(--text-soft)'};
//   font-size: 1.05rem;
//   font-weight: 600;
//   cursor: pointer;
//   transition: all 0.2s;

//   &:hover {
//     color: ${({ $active }) => $active ? '#dc2626' : 'var(--text-main)'};
//     transform: translateY(-2px);
//   }

//   &:disabled {
//     opacity: 0.5;
//     cursor: not-allowed;
//   }

//   svg {
//     font-size: 1.2rem;
//   }
// `;

// const CommentsSection = styled.div`
//   margin-top: 20px;
//   max-height: 400px;
//   overflow-y: auto;
// `;

// const CommentInputWrapper = styled.form`
//   display: flex;
//   gap: 12px;
//   margin-bottom: 24px;
  
//   @media (max-width: 576px) {
//     flex-direction: column;
//   }
// `;

// const CommentInput = styled.input`
//   flex: 1;
//   padding: 14px 20px;
//   border-radius: 99px;
//   border: 1px solid var(--border);
//   background: var(--input-bg);
//   color: var(--text-main);
//   outline: none;
//   transition: border 0.3s;

//   &:focus {
//     border-color: #ef4444;
//   }
  
//   &:disabled {
//     opacity: 0.5;
//   }
// `;

// const SubmitCommentBtn = styled.button`
//   background: #ef4444;
//   color: white;
//   border: none;
//   width: 48px;
//   height: 48px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   transition: background 0.2s;

//   &:hover {
//     background: #dc2626;
//   }
  
//   &:disabled {
//     opacity: 0.5;
//     cursor: not-allowed;
//   }
// `;

// const CommentList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
// `;

// const CommentItem = styled.div`
//   display: flex;
//   gap: 12px;
//   animation: fadeIn 0.3s ease-in;
  
//   @keyframes fadeIn {
//     from { opacity: 0; transform: translateY(-10px); }
//     to { opacity: 1; transform: translateY(0); }
//   }
// `;

// const Avatar = styled.div`
//   width: 40px;
//   height: 40px;
//   border-radius: 50%;
//   background: linear-gradient(135deg, #3b82f6, #2563eb);
//   color: white;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: bold;
//   flex-shrink: 0;
// `;

// const CommentContent = styled.div`
//   background: var(--input-bg);
//   padding: 12px 16px;
//   border-radius: 0 16px 16px 16px;
//   border: 1px solid var(--border);
//   flex: 1;
// `;

// const CommentName = styled.h4`
//   margin: 0 0 4px 0;
//   font-size: 0.9rem;
//   color: var(--text-main);
// `;

// const CommentText = styled.p`
//   margin: 0;
//   font-size: 0.95rem;
//   color: var(--text-soft);
//   word-break: break-word;
// `;

// const CommentTime = styled.span`
//   font-size: 0.75rem;
//   color: var(--text-soft);
//   opacity: 0.6;
// `;

// const LoadingSpinner = styled.div`
//   display: flex;
//   justify-content: center;
//   padding: 40px;
//   color: var(--text-soft);
  
//   svg {
//     animation: spin 1s linear infinite;
//   }
  
//   @keyframes spin {
//     from { transform: rotate(0deg); }
//     to { transform: rotate(360deg); }
//   }
// `;

// const BufferingOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.4);
//   color: white;
//   z-index: 5;
//   pointer-events: none; /* Allows clicks to pass through to the video */
  
//   svg {
//     animation: spin 1s linear infinite;
//   }
// `;
// /* ================= COMPONENT ================= */
// const PerformanceOnGoals = ({ user, collapsed, setCollapsed }) => {
//   const { isDarkMode } = useTheme();
  
//   // Video states
//   const [videoData, setVideoData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const videoRef = useRef(null);
  
//   // Player states
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isMuted, setIsMuted] = useState(true); // Must be true for autoplay to work in modern browsers
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [showControls, setShowControls] = useState(false);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [isLive, setIsLive] = useState(false);
//   const [isBuffering, setIsBuffering] = useState(true); // New buffering state
  
//   // Interaction states
//   const [isLiked, setIsLiked] = useState(false);
//   const [likeCount, setLikeCount] = useState(0);
//   const [showComments, setShowComments] = useState(false);
//   const [newComment, setNewComment] = useState("");
//   const [comments, setComments] = useState([]);
//   const [commentLoading, setCommentLoading] = useState(false);
//   const [commentSubmitting, setCommentSubmitting] = useState(false);

//   // Fetch video data
//   useEffect(() => {
//     const fetchVideo = async () => {
//       try {
//         setLoading(true);
//         let activeVideo = null;
        
//         // 1. Try to get live stream first
//         try {
//           const liveResponse = await api.get('/videosLead/live');
//           if (liveResponse.data.success && liveResponse.data.data) {
//             activeVideo = liveResponse.data.data;
//             setIsLive(true);
//           }
//         } catch (liveErr) {
//           if (liveErr.response?.status !== 404) throw liveErr; 
//         }
        
//         // 2. If no live stream was found, fetch fallback videos
//         if (!activeVideo) {
//           const allVideos = await api.get('/videosLead');
//           if (allVideos.data.success && allVideos.data.data.length > 0) {
//             activeVideo = allVideos.data.data[0];
//             setIsLive(false);
//           }
//         }

//         // 3. Process whichever video we found
//         if (activeVideo && activeVideo._id) {
//           setVideoData(activeVideo);
//           setLikeCount(activeVideo.likeCount || 0);
          
//           await fetchComments(activeVideo._id);
//           await checkLikeStatus(activeVideo._id);
//         } else {
//           setError('No video available. Please check back later.');
//         }
        
//       } catch (err) {
//         console.error('Error fetching video:', err);
//         setError('An error occurred while loading the video.');
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchVideo();
//   }, []);

//   // Programmatic Autoplay for Live Streams
//   useEffect(() => {
//     if (videoData && isLive && videoRef.current) {
//       // Modern browsers require handling the promise returned by play()
//       const playPromise = videoRef.current.play();
//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             setIsPlaying(true);
//           })
//           .catch(error => {
//             console.log("Autoplay was prevented by the browser:", error);
//             setIsPlaying(false);
//           });
//       }
//     }
//   }, [videoData, isLive]);

//   // Fetch comments - with validation
//   const fetchComments = async (videoId) => {
//     if (!videoId || videoId === 'undefined') return;
//     try {
//       setCommentLoading(true);
//       const response = await api.get(`/videosLead/${videoId}/comments`);
//       if (response.data.success) {
//         setComments(response.data.data || []);
//       }
//     } catch (err) {
//       console.error('Error fetching comments:', err);
//     } finally {
//       setCommentLoading(false);
//     }
//   };

//   // Check like status - with validation
//   const checkLikeStatus = async (videoId) => {
//     if (!videoId || videoId === 'undefined') return;
//     try {
//       const userId = user?.id || localStorage.getItem('leadId');
//       if (!userId) return;
      
//       const response = await api.get(`/videosLead/${videoId}/like-status`, {
//         params: { userId }
//       });
      
//       if (response.data.success) {
//         setIsLiked(response.data.data.liked || false);
//         setLikeCount(response.data.data.likeCount || 0);
//       }
//     } catch (err) {
//       console.error('Error checking like status:', err);
//     }
//   };

//   // Video player controls
//   const handlePlayPause = () => {
//     if (videoRef.current) {
//       if (isPlaying) {
//         videoRef.current.pause();
//       } else {
//         videoRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   const handleMuteToggle = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = !videoRef.current.muted;
//       setIsMuted(!isMuted);
//     }
//   };

//   const handleFullscreen = () => {
//     if (videoRef.current) {
//       if (!document.fullscreenElement) {
//         videoRef.current.requestFullscreen();
//       } else {
//         document.exitFullscreen();
//       }
//       setIsFullscreen(!isFullscreen);
//     }
//   };

//   const handleTimeUpdate = () => {
//     if (videoRef.current) {
//       const current = videoRef.current.currentTime;
//       const total = videoRef.current.duration || 1;
//       setCurrentTime(current);
//       setProgress((current / total) * 100);
//     }
//   };

//   const handleLoadedMetadata = () => {
//     if (videoRef.current) {
//       setDuration(videoRef.current.duration);
//     }
//   };

//   const handleProgressChange = (e) => {
//     if (videoRef.current) {
//       const newProgress = parseFloat(e.target.value);
//       const newTime = (newProgress / 100) * duration;
//       videoRef.current.currentTime = newTime;
//       setProgress(newProgress);
//     }
//   };

//   const formatTime = (seconds) => {
//     if (!seconds || isNaN(seconds)) return '0:00';
//     const mins = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${mins}:${secs.toString().padStart(2, '0')}`;
//   };

//   // Interaction handlers
//   const handleLike = async () => {
//     if (!videoData) return;
//     try {
//       const userId = user?.id || localStorage.getItem('leadId');
//       const userEmail = user?.email || localStorage.getItem('userEmail');
      
//       if (!userId) {
//         alert('Please login to like this video');
//         return;
//       }
      
//       setIsLiked(!isLiked);
//       setLikeCount(prev => isLiked ? prev - 1 : prev + 1);
      
//       const response = await api.post(`/videosLead/${videoData._id}/like`, { userId, userEmail });
      
//       if (response.data.success) {
//         setIsLiked(response.data.data.liked);
//         setLikeCount(response.data.data.likeCount);
//       }
//     } catch (err) {
//       console.error('Error toggling like:', err);
//       setIsLiked(!isLiked);
//       setLikeCount(prev => isLiked ? prev + 1 : prev - 1);
//     }
//   };

//   const handleShare = async () => {
//     if (!videoData) return;
//     try {
//       await api.post(`/videosLead/${videoData._id}/share`);
      
//       const shareData = {
//         title: videoData.title || 'Watch this video!',
//         text: videoData.description || 'Check out this video on SPIRITMAN',
//         url: window.location.href
//       };

//       if (navigator.share) {
//         await navigator.share(shareData);
//       } else {
//         await navigator.clipboard.writeText(window.location.href);
//         alert("Link copied to clipboard!");
//       }
//     } catch (err) {
//       console.error('Error sharing:', err);
//     }
//   };

//   const handleCommentSubmit = async (e) => {
//     e.preventDefault();
//     if (!newComment.trim() || !videoData) return;
//     try {
//       const userId = user?.id || localStorage.getItem('leadId');
//       const userEmail = user?.email || localStorage.getItem('userEmail');
//       const userName = user?.name || user?.username || 'Anonymous';
      
//       if (!userId) {
//         alert('Please login to comment');
//         return;
//       }
      
//       setCommentSubmitting(true);
//       const response = await api.post(`/videosLead/${videoData._id}/comments`, {
//         text: newComment.trim(), userId, userEmail, userName
//       });
      
//       if (response.data.success) {
//         setComments([response.data.data, ...comments]);
//         setNewComment("");
//       }
//     } catch (err) {
//       console.error('Error posting comment:', err);
//       alert('Failed to post comment. Please try again.');
//     } finally {
//       setCommentSubmitting(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />
//         <Main>
//           <LoadingSpinner>
//             <FaSpinner size={40} />
//           </LoadingSpinner>
//         </Main>
//         <Footer />
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//         <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//         <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />
//         <Main>
//           <div style={{ textAlign: 'center', padding: '60px 20px', color: '#ef4444' }}>
//             <h2>⚠️ {error}</h2>
//           </div>
//         </Main>
//         <Footer />
//       </Container>
//     );
//   }

//   return (
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />

//       <Main>
//         <HeroPanel>
//           <HeroTitle>
//             {isLive ? '🔴 Live Stream' : '🎬 Video Program'}
//           </HeroTitle>
//         </HeroPanel>

//         <div style={{ padding: '16px 28px 0', borderBottom: '1px solid var(--border)' }}>
//           <h2 style={{ margin: '0 0 8px 0', color: 'var(--text-main)' }}>
//             {videoData?.title || 'Live Program'}
//           </h2>
//           {videoData?.description && (
//             <p style={{ color: 'var(--text-soft)', margin: '0 0 16px 0' }}>
//               {videoData.description}
//             </p>
//           )}
//         </div>

//         <VideoSection>
//           <VideoWrapper>
//             {/* Buffering Indicator */}
//             {isBuffering && (
//               <BufferingOverlay>
//                 <FaSpinner size={48} />
//               </BufferingOverlay>
//             )}

//             <video 
//               ref={videoRef}
//               controls={false}
//               autoPlay={isLive}
//               muted={isMuted}
//               poster={videoData?.poster || videoData?.thumbnail}
//               onTimeUpdate={handleTimeUpdate}
//               onLoadedMetadata={handleLoadedMetadata}
              
//               /* Buffering & Playback Events */
//               onLoadStart={() => setIsBuffering(true)}
//               onWaiting={() => setIsBuffering(true)}
//               onCanPlay={() => setIsBuffering(false)}
//               onPlaying={() => {
//                 setIsBuffering(false);
//                 setIsPlaying(true);
//               }}
//               onPlay={() => setIsPlaying(true)}
//               onPause={() => setIsPlaying(false)}
//               onClick={() => setShowControls(!showControls)}
//             >
//               <source src={videoData?.videoUrl} type="video/mp4" />
//               {videoData?.videoType === 'livestream' && (
//                 <source src={videoData?.videoUrl} type="application/vnd.apple.mpegurl" />
//               )}
//               Your browser does not support the video tag.
//             </video>
            
//             {isLive && (
//               <LiveBadge>
//                 <span className="dot" /> LIVE
//               </LiveBadge>
//             )}
            
//             <VideoControls $visible={showControls}>
//               <ControlButton onClick={handlePlayPause}>
//                 {isPlaying ? <FaPause /> : <FaPlay />}
//               </ControlButton>
              
//               <ControlButton onClick={handleMuteToggle}>
//                 {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
//               </ControlButton>
              
//               <TimeDisplay>
//                 {isLive ? 'Live' : `${formatTime(currentTime)} / ${formatTime(duration)}`}
//               </TimeDisplay>
              
//               <ProgressBar 
//                 type="range"
//                 min="0"
//                 max="100"
//                 value={progress}
//                 onChange={handleProgressChange}
//                 disabled={isLive}
//               />
              
//               <ControlButton onClick={handleFullscreen}>
//                 {isFullscreen ? <FaCompress /> : <FaExpand />}
//               </ControlButton>
//             </VideoControls>
//           </VideoWrapper>

//           <InteractionsContainer>
//             {/* ... Rest of your InteractionsContainer remains unchanged ... */}
//             <ActionRow>
//               <ActionButton $active={isLiked} onClick={handleLike}>
//                 {isLiked ? <FaHeart /> : <FaRegHeart />} 
//                 {likeCount} Likes
//               </ActionButton>
              
//               <ActionButton onClick={() => setShowComments(!showComments)}>
//                 <FaComment /> {comments.length} Comments
//               </ActionButton>

//               <ActionButton onClick={handleShare}>
//                 <FaShare /> Share
//               </ActionButton>
//             </ActionRow>

//             {showComments && (
//               <CommentsSection>
//                 <CommentInputWrapper onSubmit={handleCommentSubmit}>
//                   <CommentInput 
//                     placeholder="Write a comment..." 
//                     value={newComment}
//                     onChange={(e) => setNewComment(e.target.value)}
//                     disabled={commentSubmitting}
//                   />
//                   <SubmitCommentBtn type="submit" disabled={!newComment.trim() || commentSubmitting}>
//                     {commentSubmitting ? <FaSpinner style={{ animation: 'spin 1s linear infinite' }} /> : <FaPaperPlane />}
//                   </SubmitCommentBtn>
//                 </CommentInputWrapper>

//                 {commentLoading ? (
//                   <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-soft)' }}>
//                     Loading comments...
//                   </div>
//                 ) : (
//                   <CommentList>
//                     {comments.length === 0 ? (
//                       <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-soft)' }}>
//                         No comments yet. Be the first to comment!
//                       </div>
//                     ) : (
//                       comments.map(comment => (
//                         <CommentItem key={comment.id}>
//                           <Avatar>{comment.userName?.charAt(0).toUpperCase() || 'U'}</Avatar>
//                           <CommentContent>
//                             <CommentName>
//                               {comment.userName}
//                               <CommentTime> • {new Date(comment.createdAt).toLocaleDateString()}</CommentTime>
//                             </CommentName>
//                             <CommentText>{comment.text}</CommentText>
//                           </CommentContent>
//                         </CommentItem>
//                       ))
//                     )}
//                   </CommentList>
//                 )}
//               </CommentsSection>
//             )}
//           </InteractionsContainer>
//         </VideoSection>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default PerformanceOnGoals;


import React, { useEffect, useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { 
  FaCheckCircle, FaLock, FaThumbsUp, FaRegThumbsUp, 
  FaComment, FaShare, FaPaperPlane, FaHeart, FaRegHeart,
  FaPlay, FaPause, FaExpand, FaCompress, FaVolumeUp,
  FaVolumeMute, FaSpinner, FaVideo
} from "react-icons/fa";
import Navbar from "./Navbar";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import api from "../api";
import { useTheme } from "../App"; 

/* ================= HELPERS ================= */
const getCurrentMonthName = () => {
  const date = new Date();
  return date.toLocaleString("default", { month: "long", year: "numeric" });
};

const generateMonthOptions = () => {
  const months = [];
  const date = new Date();
  date.setMonth(date.getMonth() - 3); 
  for (let i = 0; i < 12; i++) {
    months.push(date.toLocaleString('default', { month: 'long', year: 'numeric' }));
    date.setMonth(date.getMonth() + 1);
  }
  return months;
};

const parseScoreValue = (value) => {
  if (value === "N/A" || value === "" || value == null) return null;
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

/* ================= PAGE LAYOUT & THEME VARIABLES ================= */
const Container = styled.div`
  --sidebar-expanded: 260px; --sidebar-collapsed: 90px;
  
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
  --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
  --table-header-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#fef2f2'};
  --table-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
  
  min-height: 100vh; background: var(--page-bg); color: var(--text-main);
  margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;
  @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
  @media (max-width: 768px) { margin-left: 0; }
`;

const Main = styled.main`
  width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 4px 0 40px;
  @media (max-width: 1024px) { width: min(100%, calc(100% - 24px)); padding: 86px 0 32px; }
  @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); padding: 80px 0 24px; }
`;

const HeroPanel = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #991b1b 45%, #dc2626 100%); 
  color: white; padding: 28px; border-radius: 28px; 
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.08); 
  position: relative; overflow: hidden; margin-bottom: 24px;
  
  @media (max-width: 576px) { padding: 22px 18px; border-radius: 22px; }
`;

const HeroTitle = styled.h1` 
  margin: 0; font-size: clamp(1.6rem, 1.2rem + 1.5vw, 2.5rem); 
  line-height: 1.1; font-weight: 800; margin-bottom: 14px; 
`;

/* ================= VIDEO PLAYER COMPONENTS ================= */
const VideoSection = styled.div`
  background: var(--card-bg);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  border: 1px solid var(--border);
`;

const VideoWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
  background: #000;
  
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
  }
  
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const LiveBadge = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  background: #ef4444;
  color: white;
  padding: 6px 16px;
  border-radius: 99px;
  font-weight: 700;
  font-size: 0.85rem;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: pulse 1.5s ease-in-out infinite;
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
  
  .dot {
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
  }
`;

const VideoControls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 16px;
  opacity: ${({ $visible }) => $visible ? '1' : '0'};
  transition: opacity 0.3s;
`;

const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4rem;
  cursor: pointer;
  padding: 4px 8px;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.1);
  }
`;

const ProgressBar = styled.input`
  flex: 1;
  -webkit-appearance: none;
  background: rgba(255,255,255,0.3);
  height: 4px;
  border-radius: 2px;
  outline: none;
  
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ef4444;
    cursor: pointer;
  }
`;

const TimeDisplay = styled.span`
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
  min-width: 80px;
`;

/* ================= INTERACTIONS COMPONENTS ================= */
const InteractionsContainer = styled.div`
  padding: 20px 28px;
  
  @media (max-width: 576px) {
    padding: 16px;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  border-bottom: 1px solid var(--border);
  padding-bottom: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  
  @media (max-width: 576px) {
    gap: 16px;
  }
`;

const ActionButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ $active }) => $active ? '#ef4444' : 'var(--text-soft)'};
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: ${({ $active }) => $active ? '#dc2626' : 'var(--text-main)'};
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    font-size: 1.2rem;
  }
`;

const CommentsSection = styled.div`
  margin-top: 20px;
  max-height: 400px;
  overflow-y: auto;
`;

const CommentInputWrapper = styled.form`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const CommentInput = styled.input`
  flex: 1;
  padding: 14px 20px;
  border-radius: 99px;
  border: 1px solid var(--border);
  background: var(--input-bg);
  color: var(--text-main);
  outline: none;
  transition: border 0.3s;

  &:focus {
    border-color: #ef4444;
  }
  
  &:disabled {
    opacity: 0.5;
  }
`;

const SubmitCommentBtn = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #dc2626;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const CommentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CommentItem = styled.div`
  display: flex;
  gap: 12px;
  animation: fadeIn 0.3s ease-in;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
`;

const CommentContent = styled.div`
  background: var(--input-bg);
  padding: 12px 16px;
  border-radius: 0 16px 16px 16px;
  border: 1px solid var(--border);
  flex: 1;
`;

const CommentName = styled.h4`
  margin: 0 0 4px 0;
  font-size: 0.9rem;
  color: var(--text-main);
`;

const CommentText = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-soft);
  word-break: break-word;
`;

const CommentTime = styled.span`
  font-size: 0.75rem;
  color: var(--text-soft);
  opacity: 0.6;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px;
  color: var(--text-soft);
  
  svg {
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const BufferingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  z-index: 5;
  pointer-events: none;
  
  svg {
    animation: spin 1s linear infinite;
  }
`;

/* ================= NO VIDEO PLACEHOLDER ================= */
const NoVideoPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  color: white;
  padding: 20px;
  text-align: center;
  
  svg {
    font-size: 64px;
    color: #ef4444;
    margin-bottom: 20px;
    opacity: 0.5;
  }
  
  h3 {
    font-size: 1.5rem;
    margin: 0 0 8px 0;
  }
  
  p {
    color: #94a3b8;
    margin: 0;
    font-size: 1rem;
  }
`;

/* ================= COMPONENT ================= */
const PerformanceOnGoals = ({ user, collapsed, setCollapsed }) => {
  const { isDarkMode } = useTheme();
  
  // Video states
  const [videoData, setVideoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);
  
  // Player states
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [showControls, setShowControls] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [isBuffering, setIsBuffering] = useState(true);
  
  // Interaction states
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [showComments, setShowComments] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentSubmitting, setCommentSubmitting] = useState(false);

  // Fetch video data
  useEffect(() => {
    const fetchVideo = async () => {
      try {
        setLoading(true);
        let activeVideo = null;
        
        // 1. Try to get live stream first
        try {
          const liveResponse = await api.get('/videosLead/live');
          if (liveResponse.data.success && liveResponse.data.data) {
            activeVideo = liveResponse.data.data;
            setIsLive(true);
          }
        } catch (liveErr) {
          if (liveErr.response?.status !== 404) throw liveErr; 
        }
        
        // 2. If no live stream was found, fetch fallback videos
        if (!activeVideo) {
          const allVideos = await api.get('/videosLead');
          if (allVideos.data.success && allVideos.data.data.length > 0) {
            activeVideo = allVideos.data.data[0];
            setIsLive(false);
          }
        }

        // 3. Process whichever video we found
        if (activeVideo && activeVideo._id) {
          setVideoData(activeVideo);
          setLikeCount(activeVideo.likeCount || 0);
          
          await fetchComments(activeVideo._id);
          await checkLikeStatus(activeVideo._id);
        } else {
          setError('No video available. Please check back later.');
        }
        
      } catch (err) {
        console.error('Error fetching video:', err);
        setError('An error occurred while loading the video.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchVideo();
  }, []);

  // Programmatic Autoplay for Live Streams
  useEffect(() => {
    if (videoData && isLive && videoRef.current && videoData.videoUrl) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => setIsPlaying(true))
          .catch(error => {
            console.log("Autoplay was prevented by the browser:", error);
            setIsPlaying(false);
          });
      }
    }
  }, [videoData, isLive]);

  // Fetch comments - with validation
  const fetchComments = async (videoId) => {
    if (!videoId || videoId === 'undefined') return;
    try {
      setCommentLoading(true);
      const response = await api.get(`/videosLead/${videoId}/comments`);
      if (response.data.success) {
        setComments(response.data.data || []);
      }
    } catch (err) {
      console.error('Error fetching comments:', err);
    } finally {
      setCommentLoading(false);
    }
  };

  // Check like status - with validation
  const checkLikeStatus = async (videoId) => {
    if (!videoId || videoId === 'undefined') return;
    try {
      const userId = user?.id || localStorage.getItem('leadId');
      if (!userId) return;
      
      const response = await api.get(`/videosLead/${videoId}/like-status`, {
        params: { userId }
      });
      
      if (response.data.success) {
        setIsLiked(response.data.data.liked || false);
        setLikeCount(response.data.data.likeCount || 0);
      }
    } catch (err) {
      console.error('Error checking like status:', err);
    }
  };

  // Video player controls
  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleMuteToggle = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  const handleFullscreen = () => {
    if (videoRef.current) {
      if (!document.fullscreenElement) {
        videoRef.current.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
      setIsFullscreen(!isFullscreen);
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const current = videoRef.current.currentTime;
      const total = videoRef.current.duration || 1;
      setCurrentTime(current);
      setProgress((current / total) * 100);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const handleProgressChange = (e) => {
    if (videoRef.current) {
      const newProgress = parseFloat(e.target.value);
      const newTime = (newProgress / 100) * duration;
      videoRef.current.currentTime = newTime;
      setProgress(newProgress);
    }
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Interaction handlers
  const handleLike = async () => {
    if (!videoData) return;
    try {
      const userId = user?.id || localStorage.getItem('leadId');
      const userEmail = user?.email || localStorage.getItem('userEmail');
      
      if (!userId) {
        alert('Please login to like this video');
        return;
      }
      
      setIsLiked(!isLiked);
      setLikeCount(prev => isLiked ? prev - 1 : prev + 1);
      
      const response = await api.post(`/videosLead/${videoData._id}/like`, { userId, userEmail });
      
      if (response.data.success) {
        setIsLiked(response.data.data.liked);
        setLikeCount(response.data.data.likeCount);
      }
    } catch (err) {
      console.error('Error toggling like:', err);
      setIsLiked(!isLiked);
      setLikeCount(prev => isLiked ? prev + 1 : prev - 1);
    }
  };

  const handleShare = async () => {
    if (!videoData) return;
    try {
      await api.post(`/videosLead/${videoData._id}/share`);
      
      const shareData = {
        title: videoData.title || 'Watch this video!',
        text: videoData.description || 'Check out this video on SPIRITMAN',
        url: window.location.href
      };

      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied to clipboard!");
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim() || !videoData) return;
    try {
      const userId = user?.id || localStorage.getItem('leadId');
      const userEmail = user?.email || localStorage.getItem('userEmail');
      const userName = user?.name || user?.username || 'Anonymous';
      
      if (!userId) {
        alert('Please login to comment');
        return;
      }
      
      setCommentSubmitting(true);
      const response = await api.post(`/videosLead/${videoData._id}/comments`, {
        text: newComment.trim(), userId, userEmail, userName
      });
      
      if (response.data.success) {
        setComments([response.data.data, ...comments]);
        setNewComment("");
      }
    } catch (err) {
      console.error('Error posting comment:', err);
      alert('Failed to post comment. Please try again.');
    } finally {
      setCommentSubmitting(false);
    }
  };

  // Check if we should show the embed (if no videoUrl)
  const showEmbed = videoData && !videoData.videoUrl;

  if (loading) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
        <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />
        <Main>
          <LoadingSpinner>
            <FaSpinner size={40} />
          </LoadingSpinner>
        </Main>
        <Footer />
      </Container>
    );
  }

  if (error) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
        <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />
        <Main>
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#ef4444' }}>
            <h2>⚠️ {error}</h2>
          </div>
        </Main>
        <Footer />
      </Container>
    );
  }

  return (
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      <DashboardHeader user={user} collapsed={collapsed} title="Live Program" />

      <Main>
        <HeroPanel>
          <HeroTitle>
            {isLive ? '🔴 Live Stream' : '🎬 Video Program'}
          </HeroTitle>
        </HeroPanel>

        <div style={{ padding: '16px 28px 0', borderBottom: '1px solid var(--border)' }}>
          <h2 style={{ margin: '0 0 8px 0', color: 'var(--text-main)' }}>
            {videoData?.title || 'Live Program'}
          </h2>
          {videoData?.description && (
            <p style={{ color: 'var(--text-soft)', margin: '0 0 16px 0' }}>
              {videoData.description}
            </p>
          )}
        </div>

        <VideoSection>
          <VideoWrapper>
            {/* Show embed if no videoUrl, otherwise show video player */}
            {showEmbed ? (
              <iframe 
                src="https://embed.ceflix.org/video/1898510"
                width="100%"
                height="100%"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded Video"
              />
            ) : (
              <>
                {/* Buffering Indicator */}
                {isBuffering && (
                  <BufferingOverlay>
                    <FaSpinner size={48} />
                  </BufferingOverlay>
                )}

                <video 
                  ref={videoRef}
                  controls={false}
                  autoPlay={isLive}
                  muted={isMuted}
                  poster={videoData?.poster || videoData?.thumbnail}
                  onTimeUpdate={handleTimeUpdate}
                  onLoadedMetadata={handleLoadedMetadata}
                  onLoadStart={() => setIsBuffering(true)}
                  onWaiting={() => setIsBuffering(true)}
                  onCanPlay={() => setIsBuffering(false)}
                  onPlaying={() => {
                    setIsBuffering(false);
                    setIsPlaying(true);
                  }}
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                  onClick={() => setShowControls(!showControls)}
                >
                  <source src={videoData?.videoUrl} type="video/mp4" />
                  {videoData?.videoType === 'livestream' && (
                    <source src={videoData?.videoUrl} type="application/vnd.apple.mpegurl" />
                  )}
                  Your browser does not support the video tag.
                </video>
                
                {isLive && (
                  <LiveBadge>
                    <span className="dot" /> LIVE
                  </LiveBadge>
                )}
                
                <VideoControls $visible={showControls}>
                  <ControlButton onClick={handlePlayPause}>
                    {isPlaying ? <FaPause /> : <FaPlay />}
                  </ControlButton>
                  
                  <ControlButton onClick={handleMuteToggle}>
                    {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                  </ControlButton>
                  
                  <TimeDisplay>
                    {isLive ? 'Live' : `${formatTime(currentTime)} / ${formatTime(duration)}`}
                  </TimeDisplay>
                  
                  <ProgressBar 
                    type="range"
                    min="0"
                    max="100"
                    value={progress}
                    onChange={handleProgressChange}
                    disabled={isLive}
                  />
                  
                  <ControlButton onClick={handleFullscreen}>
                    {isFullscreen ? <FaCompress /> : <FaExpand />}
                  </ControlButton>
                </VideoControls>
              </>
            )}
          </VideoWrapper>

          <InteractionsContainer>
            <ActionRow>
              <ActionButton $active={isLiked} onClick={handleLike}>
                {isLiked ? <FaHeart /> : <FaRegHeart />} 
                {likeCount} Likes
              </ActionButton>
              
              <ActionButton onClick={() => setShowComments(!showComments)}>
                <FaComment /> {comments.length} Comments
              </ActionButton>

              <ActionButton onClick={handleShare}>
                <FaShare /> Share
              </ActionButton>
            </ActionRow>

            {showComments && (
              <CommentsSection>
                <CommentInputWrapper onSubmit={handleCommentSubmit}>
                  <CommentInput 
                    placeholder="Write a comment..." 
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    disabled={commentSubmitting}
                  />
                  <SubmitCommentBtn type="submit" disabled={!newComment.trim() || commentSubmitting}>
                    {commentSubmitting ? <FaSpinner style={{ animation: 'spin 1s linear infinite' }} /> : <FaPaperPlane />}
                  </SubmitCommentBtn>
                </CommentInputWrapper>

                {commentLoading ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-soft)' }}>
                    Loading comments...
                  </div>
                ) : (
                  <CommentList>
                    {comments.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-soft)' }}>
                        No comments yet. Be the first to comment!
                      </div>
                    ) : (
                      comments.map(comment => (
                        <CommentItem key={comment.id}>
                          <Avatar>{comment.userName?.charAt(0).toUpperCase() || 'U'}</Avatar>
                          <CommentContent>
                            <CommentName>
                              {comment.userName}
                              <CommentTime> • {new Date(comment.createdAt).toLocaleDateString()}</CommentTime>
                            </CommentName>
                            <CommentText>{comment.text}</CommentText>
                          </CommentContent>
                        </CommentItem>
                      ))
                    )}
                  </CommentList>
                )}
              </CommentsSection>
            )}
          </InteractionsContainer>
        </VideoSection>
      </Main>
      <Footer />
    </Container>
  );
};

export default PerformanceOnGoals;